import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as dateFormat from "dateformat";
import { Field, reduxForm, formValueSelector } from "redux-form";
import { SubmissionError } from "redux-form";

import Box from "../components/Box";
import LoadingProgress from "../components/LoadingProgress";

import { fetchMatrixs } from "../actions/matrixs";
import { fetchMachines } from "../actions/machines";
import { addAudit } from "../actions/audits";

import ErrorMessage from "../components/ErrorMessage";

import { renderInputField, renderSelectField } from "../utils/forms";

import "../styles/PinView.css";

class PinView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      phoneValue: "",
      emailValue: "",
      nameValue: "",
      lockerResult: 0,
      lockerType: "",
      lockerPass: "000000",
      machineResult: "XXXX",
      machineFirstIndex: 0,
      ticketRender: [],
    };
  }

  componentDidMount() {
    this.props.fetchMatrixs("", "", "", "");
    this.props.fetchMachines();
  }

  renderResultPhone(e) {
    const { matrixs, machines } = this.props;

    const ticketRender = [];

    let searchLockerResult = 0;
    let lockerSelected = "";
    let searchLockerPass = "";
    let searchMachineResult = "";
    let searchMachineFirstIndex = 0;

    let printIndex = 0;

    matrixs.map((matrix) => {
      matrix.Locker.map((lock, index) => {
        if (
          lock.Phone === this.state.phoneValue ||
          "+" + lock.Phone === this.state.phoneValue
        ) {
          machines.map((machine) => {
            if (machine.Serial === matrix.Serial) {
              searchMachineFirstIndex = parseInt(machine.FirstIndex);
              searchMachineResult = machine.Serial;

              const audit = {
                TimeStamp: new Date(),
                Machine: machine._id,
                Categoria: "PIN_RECOVER",
                Evento: "RECUPERACIÓN DE PIN PDA",
                Description: "Taquilla: " + (index + searchMachineFirstIndex),
                WorkerSession: "000000",
                Customer: machine.Customer._id,
              };

              this.props.addAudit(audit);
            }
          });
          searchLockerResult = index + searchMachineFirstIndex;
          searchLockerPass = lock.Pass;
          lockerSelected = lock.Mode + lock.Wide + lock.Type;

          switch (lockerSelected) {
            // Voucher/Coupon Locker Types (XN and XW, no LOCKER prefix)
            case "XNS":
              lockerSelected = "Standard Cupón";
              break;
            case "XWS":
              lockerSelected = "Standard XL Cupón";
              break;
            case "XNM":
              lockerSelected = "Medium Cupón";
              break;
            case "XWM":
              lockerSelected = "Medium XL Cupón";
              break;
            case "XNL":
              lockerSelected = "Large Cupón";
              break;
            case "XWL":
              lockerSelected = "Large XL Cupón";
              break;
            case "XNXL":
              lockerSelected = "Large 4 Cupón";
              break;
            case "XWXL":
              lockerSelected = "Large 4 XL Cupón";
              break;
            case "XN2XL":
              lockerSelected = "Large 5 Cupón";
              break;
            case "XW2XL":
              lockerSelected = "Large 5 XL Cupón";
              break;
            case "XN3XL":
              lockerSelected = "Ski Cupón";
              break;
            case "XW3XL":
              lockerSelected = "Ski XL Cupón";
              break;
            case "BNS":
              lockerSelected = "Standard";
              break;
            case "CNS":
              lockerSelected = "Standard Carga";
              break;
            case "BWS":
              lockerSelected = "Standard XL";
              break;
            case "BWS":
              lockerSelected = "Standard Carga XL";
              break;
            case "BNM":
              lockerSelected = "Medium";
              break;
            case "CNM":
              lockerSelected = "Medium Carga";
              break;
            case "BWM":
              lockerSelected = "Medium XL";
              break;
            case "CWM":
              lockerSelected = "Medium Carga XL";
              break;
            case "BNL":
              lockerSelected = "Large";
              break;
            case "CNL":
              lockerSelected = "Large Carga";
              break;
            case "BWL":
              lockerSelected = "Large XL";
              break;
            case "CWL":
              lockerSelected = "Large Carga XL";
              break;
            case "BNXL":
              lockerSelected = "Large";
              break;
            case "CNXL":
              lockerSelected = "Large Carga";
              break;
            case "BWXL":
              lockerSelected = "Large XL";
              break;
            case "CWXL":
              lockerSelected = "LargeCarga XL";
              break;
            case "BN2XL":
              lockerSelected = "Large";
              break;
            case "CN2XL":
              lockerSelected = "Large Carga";
              break;
            case "BW2XL":
              lockerSelected = "Large XL";
              break;
            case "CW2XL":
              lockerSelected = "Large Carga XL";
              break;
            case "BN3XL":
              lockerSelected = "2 Equipos de Esquí";
              break;
            case "CN3XL":
              lockerSelected = "3 Equipos de Esquí";
              break;
            case "BW3XL":
              lockerSelected = "4 Equipos de Esquí";
              break;
            case "CW3XL":
              lockerSelected = "Ski Carga XL";
              break;
          }

          printIndex++;

          ticketRender.push(
            <div className="pin-ticket-container">
              <div className="pin-ticket" id={`ticket-${printIndex}`}>
                <div className="pin-ticket-header">
                  
                  Ticket de Recuperación PIN
                </div>
                <div className="pin-ticket-body">
                  <div className="pin-ticket-row">
                    <div className="pin-ticket-label">Taquilla</div>
                    <div className="pin-ticket-value pin-ticket-number">{searchLockerResult}</div>
                  </div>
                  <div className="pin-ticket-row">
                    <div className="pin-ticket-label">PIN</div>
                    <div className="pin-ticket-value pin-ticket-pin">{searchLockerPass}</div>
                  </div>
                  <div className="pin-ticket-row">
                    <div className="pin-ticket-label">Tipo</div>
                    <div className="pin-ticket-value">{lockerSelected}</div>
                  </div>
                  <div className="pin-ticket-row">
                    <div className="pin-ticket-label">Máquina</div>
                    <div className="pin-ticket-value">{searchMachineResult}</div>
                  </div>
                </div>
                <div className="pin-ticket-actions">
                  <button
                    className="pin-ticket-print-btn"
                    onClick={(e) =>
                      this.printLockerTicket(e, `ticket-${printIndex}`)
                    }
                  >
                    <i className="fas fa-print"></i>
                    <span>Imprimir Ticket</span>
                  </button>
                </div>
              </div>
            </div>
          );
        }
      });
    });

    if (printIndex == 0) {
      ticketRender.push(
        <div className="pin-no-results">
          <h1>TELEFONO NO ENCONTRADO / PHONE NOT FOUND</h1>
        </div>
      );
    }

    this.setState({
      ticketRender: ticketRender,
      machineResult: searchMachineResult,
      machineFirstIndex: searchMachineFirstIndex,
      lockerResult: searchLockerResult,
      lockerPass: searchLockerPass,
      lockerType: lockerSelected,
    });
  }

  renderResultEmail(e) {
    const { matrixs, machines } = this.props;

    const ticketRender = [];

    let searchLockerResult = 0;
    let lockerSelected = "";
    let searchLockerPass = "";
    let searchMachineResult = "";
    let searchMachineFirstIndex = 0;

    let printIndex = 0;

    matrixs.map((matrix) => {
      matrix.Locker.map((lock, index) => {
        if (lock.Email === this.state.emailValue) {
          machines.map((machine) => {
            if (machine.Serial === matrix.Serial) {
              searchMachineFirstIndex = parseInt(machine.FirstIndex);
              searchMachineResult = machine.Serial;

              const audit = {
                TimeStamp: new Date(),
                Machine: machine._id,
                Categoria: "PIN_RECOVER",
                Evento: "RECUPERACIÓN DE PIN PDA",
                Description: "Taquilla: " + (index + searchMachineFirstIndex),
                WorkerSession: "000000",
                Customer: machine.Customer._id,
              };

              this.props.addAudit(audit);
            }
          });
          searchLockerResult = index + searchMachineFirstIndex;
          searchLockerPass = lock.Pass;
          lockerSelected = lock.Mode + lock.Wide + lock.Type;

          switch (lockerSelected) {
            case "BNS":
              lockerSelected = "Standard";
              break;
            case "CNS":
              lockerSelected = "Standard Carga";
              break;
            case "BWS":
              lockerSelected = "Standard XL";
              break;
            case "BWS":
              lockerSelected = "Standard Carga XL";
              break;
            case "BNM":
              lockerSelected = "Medium";
              break;
            case "CNM":
              lockerSelected = "Medium Carga";
              break;
            case "BWM":
              lockerSelected = "Medium XL";
              break;
            case "CWM":
              lockerSelected = "Medium Carga XL";
              break;
            case "BNL":
              lockerSelected = "Large";
              break;
            case "CNL":
              lockerSelected = "Large Carga";
              break;
            case "BWL":
              lockerSelected = "Large XL";
              break;
            case "CWL":
              lockerSelected = "Large Carga XL";
              break;
            case "BNXL":
              lockerSelected = "Large";
              break;
            case "CNXL":
              lockerSelected = "Large Carga";
              break;
            case "BWXL":
              lockerSelected = "Large XL";
              break;
            case "CWXL":
              lockerSelected = "LargeCarga XL";
              break;
            case "BN2XL":
              lockerSelected = "Large";
              break;
            case "CN2XL":
              lockerSelected = "Large Carga";
              break;
            case "BW2XL":
              lockerSelected = "Large XL";
              break;
            case "CW2XL":
              lockerSelected = "Large Carga XL";
              break;
            case "BN3XL":
              lockerSelected = "2 Equipos de Esquí";
              break;
            case "CN3XL":
              lockerSelected = "3 Equipos de Esquí";
              break;
            case "BW3XL":
              lockerSelected = "4 Equipos de Esquí";
              break;
            case "CW3XL":
              lockerSelected = "Ski Carga XL";
              break;
          }

          printIndex++;

          ticketRender.push(
            <div className="pin-ticket-container">
              <div className="pin-ticket" id={`ticket-${printIndex}`}>
                <div className="pin-ticket-header">
                  
                  Ticket de Recuperación PIN
                </div>
                <div className="pin-ticket-body">
                  <div className="pin-ticket-row">
                    <div className="pin-ticket-label">Taquilla</div>
                    <div className="pin-ticket-value pin-ticket-number">{searchLockerResult}</div>
                  </div>
                  <div className="pin-ticket-row">
                    <div className="pin-ticket-label">PIN</div>
                    <div className="pin-ticket-value pin-ticket-pin">{searchLockerPass}</div>
                  </div>
                  <div className="pin-ticket-row">
                    <div className="pin-ticket-label">Tipo</div>
                    <div className="pin-ticket-value">{lockerSelected}</div>
                  </div>
                  <div className="pin-ticket-row">
                    <div className="pin-ticket-label">Máquina</div>
                    <div className="pin-ticket-value">{searchMachineResult}</div>
                  </div>
                </div>
                <div className="pin-ticket-actions">
                  <button
                    className="pin-ticket-print-btn"
                    onClick={(e) =>
                      this.printLockerTicket(e, `ticket-${printIndex}`)
                    }
                  >
                    <i className="fas fa-print"></i>
                    <span>Imprimir Ticket</span>
                  </button>
                </div>
              </div>
            </div>
          );
        }
      });
    });

    if (printIndex == 0) {
      ticketRender.push(
        <div className="pin-no-results">
          <h1>EMAIL NO ENCONTRADO / EMAIL NOT FOUND</h1>
        </div>
      );
    }

    this.setState({
      ticketRender: ticketRender,
      machineResult: searchMachineResult,
      machineFirstIndex: searchMachineFirstIndex,
      lockerResult: searchLockerResult,
      lockerPass: searchLockerPass,
      lockerType: lockerSelected,
    });
  }

  renderResultName(e) {
    const { matrixs, machines } = this.props;

    const ticketRender = [];

    let searchLockerResult = 0;
    let lockerSelected = "";
    let searchLockerPass = "";
    let searchMachineResult = "";
    let searchMachineFirstIndex = 0;

    let printIndex = 0;

    matrixs.map((matrix) => {
      matrix.Locker.map((lock, index) => {
        if (lock.Name === this.state.nameValue) {
          machines.map((machine) => {
            if (machine.Serial === matrix.Serial) {
              searchMachineFirstIndex = parseInt(machine.FirstIndex);
              searchMachineResult = machine.Serial;

              const audit = {
                TimeStamp: new Date(),
                Machine: machine._id,
                Categoria: "PIN_RECOVER",
                Evento: "RECUPERACIÓN DE PIN PDA",
                Description: "Taquilla: " + (index + searchMachineFirstIndex),
                WorkerSession: "000000",
                Customer: machine.Customer._id,
              };

              this.props.addAudit(audit);
            }
          });
          searchLockerResult = index + searchMachineFirstIndex;
          searchLockerPass = lock.Pass;
          lockerSelected = lock.Mode + lock.Wide + lock.Type;

          switch (lockerSelected) {
            case "BNS":
              lockerSelected = "Standard";
              break;
            case "CNS":
              lockerSelected = "Standard Carga";
              break;
            case "BWS":
              lockerSelected = "Standard XL";
              break;
            case "BWS":
              lockerSelected = "Standard Carga XL";
              break;
            case "BNM":
              lockerSelected = "Medium";
              break;
            case "CNM":
              lockerSelected = "Medium Carga";
              break;
            case "BWM":
              lockerSelected = "Medium XL";
              break;
            case "CWM":
              lockerSelected = "Medium Carga XL";
              break;
            case "BNL":
              lockerSelected = "Large";
              break;
            case "CNL":
              lockerSelected = "Large Carga";
              break;
            case "BWL":
              lockerSelected = "Large XL";
              break;
            case "CWL":
              lockerSelected = "Large Carga XL";
              break;
            case "BNXL":
              lockerSelected = "Large";
              break;
            case "CNXL":
              lockerSelected = "Large Carga";
              break;
            case "BWXL":
              lockerSelected = "Large XL";
              break;
            case "CWXL":
              lockerSelected = "LargeCarga XL";
              break;
            case "BN2XL":
              lockerSelected = "Large";
              break;
            case "CN2XL":
              lockerSelected = "Large Carga";
              break;
            case "BW2XL":
              lockerSelected = "Large XL";
              break;
            case "CW2XL":
              lockerSelected = "Large Carga XL";
              break;
            case "BN3XL":
              lockerSelected = "2 Equipos de Esquí";
              break;
            case "CN3XL":
              lockerSelected = "3 Equipos de Esquí";
              break;
            case "BW3XL":
              lockerSelected = "4 Equipos de Esquí";
              break;
            case "CW3XL":
              lockerSelected = "Ski Carga XL";
              break;
          }

          printIndex++;

          ticketRender.push(
            <div className="pin-ticket-container">
              <div className="pin-ticket" id={`ticket-${printIndex}`}>
                <div className="pin-ticket-header">
                  
                  Ticket de Recuperación PIN
                </div>
                <div className="pin-ticket-body">
                  <div className="pin-ticket-row">
                    <div className="pin-ticket-label">Taquilla</div>
                    <div className="pin-ticket-value pin-ticket-number">{searchLockerResult}</div>
                  </div>
                  <div className="pin-ticket-row">
                    <div className="pin-ticket-label">PIN</div>
                    <div className="pin-ticket-value pin-ticket-pin">{searchLockerPass}</div>
                  </div>
                  <div className="pin-ticket-row">
                    <div className="pin-ticket-label">Tipo</div>
                    <div className="pin-ticket-value">{lockerSelected}</div>
                  </div>
                  <div className="pin-ticket-row">
                    <div className="pin-ticket-label">Máquina</div>
                    <div className="pin-ticket-value">{searchMachineResult}</div>
                  </div>
                </div>
                <div className="pin-ticket-actions">
                  <button
                    className="pin-ticket-print-btn"
                    onClick={(e) =>
                      this.printLockerTicket(e, `ticket-${printIndex}`)
                    }
                  >
                    <i className="fas fa-print"></i>
                    <span>Imprimir Ticket</span>
                  </button>
                </div>
              </div>
            </div>
          );
        }
      });
    });

    if (printIndex == 0) {
      ticketRender.push(
        <div className="pin-no-results">
          <h1>NOMBRE NO ENCONTRADO / NAME NOT FOUND</h1>
        </div>
      );
    }

    this.setState({
      ticketRender: ticketRender,
      machineResult: searchMachineResult,
      machineFirstIndex: searchMachineFirstIndex,
      lockerResult: searchLockerResult,
      lockerPass: searchLockerPass,
      lockerType: lockerSelected,
    });
  }

  printLockerTicket(e, ticketId) {
    const ticketElement = document.getElementById(ticketId);
    if (!ticketElement) return;

    const content = ticketElement.innerHTML;
    const printWindow = window.open("", "", "height=600,width=400");
    printWindow.document.write("<html><head><title>PIN TICKET</title>");
    printWindow.document.write("<style>");
    printWindow.document.write(`
      body { font-family: Arial, sans-serif; margin: 0; padding: 20px; }
      .pin-ticket { border: 2px solid #000; border-radius: 8px; max-width: 80mm; margin: 0 auto; }
      .pin-ticket-header { background: #000; color: white; padding: 8px; text-align: center; font-weight: bold; }
      .pin-ticket-body { padding: 10px; }
      .pin-ticket-row { display: flex; justify-content: space-between; padding: 4px 0; border-bottom: 1px dashed #ccc; }
      .pin-ticket-row:last-child { border-bottom: none; }
      .pin-ticket-label { font-weight: bold; font-size: 10px; text-transform: uppercase; }
      .pin-ticket-value { text-align: right; font-size: 12px; }
      .pin-ticket-number { font-size: 18px; font-weight: bold; }
      .pin-ticket-pin { font-size: 16px; font-family: monospace; font-weight: bold; }
      .pin-ticket-actions { display: none; }
    `);
    printWindow.document.write("</style>");
    printWindow.document.write("</head><body>");
    printWindow.document.write(`<div class="pin-ticket">${content}</div>`);
    printWindow.document.write("</body></html>");
    printWindow.document.close();
    printWindow.print();
  }

  render() {
    const { matrixs, machines } = this.props;

    if (!matrixs || !machines) {
      return <LoadingProgress />
    }

    return (
      <div className="pin-admin-view">
        {/* Header */}
        <div className="pin-admin-header">
          <div className="header-content">
            <div className="header-text">
              <h1>
                <i className="fas fa-key mr-3"></i>
                <span className="text-vw-dark mr-1">Recuperar</span>
                <span className="text-vw-light">PIN</span>
              </h1>
            </div>
          </div>
        </div>

        {/* Search Section */}
        <div className="pin-admin-search-section">
          <div className="row">
            <div className="col-xs-12 col-sm-4 col-md-4">
              <div className="pin-search-card">
                <div className="card-header-custom">
                  <i className="fas fa-phone"></i>
                  <span>Búsqueda por teléfono</span>
                </div>
                <div className="card-body-custom">
                  <div className="input-container">
                    <input
                      placeholder="Introduce un teléfono"
                      type="tel"
                      value={this.state.phoneValue}
                      onChange={(e) => {
                        this.setState({ phoneValue: e.target.value });
                      }}
                    />
                    <div className={`input-info ${this.state.phoneValue ? 'has-value' : ''}`}>
                      {this.state.phoneValue ? `Teléfono: ${this.state.phoneValue}` : 'Sin teléfono introducido'}
                    </div>
                  </div>
                  <button
                    className="search-button"
                    onClick={(e) => this.renderResultPhone(e)}
                    disabled={this.state.phoneValue === ""}
                  >
                    <i className="fas fa-search"></i>
                    <span>Buscar</span>
                  </button>
                </div>
              </div>
            </div>
            <div className="col-xs-12 col-sm-4 col-md-4">
              <div className="pin-search-card">
                <div className="card-header-custom">
                  <i className="fas fa-envelope"></i>
                  <span>Búsqueda por email</span>
                </div>
                <div className="card-body-custom">
                  <div className="input-container">
                    <input
                      placeholder="Introduce un email"
                      type="email"
                      value={this.state.emailValue}
                      onChange={(e) => {
                        this.setState({ emailValue: e.target.value });
                      }}
                    />
                    <div className={`input-info ${this.state.emailValue ? 'has-value' : ''}`}>
                      {this.state.emailValue ? `Email: ${this.state.emailValue}` : 'Sin email introducido'}
                    </div>
                  </div>
                  <button
                    className="search-button"
                    onClick={(e) => this.renderResultEmail(e)}
                    disabled={this.state.emailValue === ""}
                  >
                    <i className="fas fa-search"></i>
                    <span>Buscar</span>
                  </button>
                </div>
              </div>
            </div>
            <div className="col-xs-12 col-sm-4 col-md-4">
              <div className="pin-search-card">
                <div className="card-header-custom">
                  <i className="fas fa-user"></i>
                  <span>Búsqueda por nombre</span>
                </div>
                <div className="card-body-custom">
                  <div className="input-container">
                    <input
                      placeholder="Introduce un nombre"
                      type="text"
                      value={this.state.nameValue}
                      onChange={(e) => {
                        this.setState({ nameValue: e.target.value });
                      }}
                    />
                    <div className={`input-info ${this.state.nameValue ? 'has-value' : ''}`}>
                      {this.state.nameValue ? `Nombre: ${this.state.nameValue}` : 'Sin nombre introducido'}
                    </div>
                  </div>
                  <button
                    className="search-button"
                    onClick={(e) => this.renderResultName(e)}
                    disabled={this.state.nameValue === ""}
                  >
                    <i className="fas fa-search"></i>
                    <span>Buscar</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Results Section */}
        <div className="pin-admin-results">
          {this.state.ticketRender}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  matrixs: state.matrixs.matrixs,
  error: state.matrixs.error,
  loading: state.matrixs.loading,
  machines: state.machines.machines,
  role: state.auth.role,
  id: state.auth.id,
  form: state.form,
});

const mapDispatchToProps = (dispatch) => ({
  fetchMatrixs: bindActionCreators(fetchMatrixs, dispatch),
  fetchMachines: bindActionCreators(fetchMachines, dispatch),
  addAudit: bindActionCreators(addAudit, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(PinView);
